<template>
  <div id="formulario-edit-info">
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vx-card>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">                  
                <label class="vs-input--label">USAR EM </label>          
                <v-select                   
                        :reduce="tipo => tipo.data" 
                        :options="listaOpcoesTipoVeiculo" 
                        v-model="data_local.tipo"      
                        :disabled="registroOriginal.hasOwnProperty('id') || !isConcept" 
                        :clearable="false"
                        class="v-select w-full vs-input--label"></v-select>  
            </div>
            <div class="vx-col w-1/3" v-if="isVeiculoGeral">                  
                    <label class="vs-input--label" >{{$t('TelaAlterarVeiculo_lTipoVeiculo')}}</label> 
                    <v-select                       
                      label="label" 
                      :reduce="tipoVeiculo => tipoVeiculo.data" 
                      :options="listaTiposVeiculos" 
                      :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"
                      v-model="data_local.tipoVeiculo"     
                      style="height: 25px">
                      <template slot="option" slot-scope="option">
                        <img :src="`${publicPath}${option.fullImage}`">
                      </template>
                      <template #selected-option="{ fullImage }">
                          <img :src="`${publicPath}${fullImage}`" style="max-height:25px">
                      </template>
                    </v-select> 
                </div>  
        </div>
        <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">                  
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_marca')}}</label> 
                <v-select                       
                    label="marca"        
                    :reduce="m => m.marca"                
                    :options="listaMarcaVeiculos" 
                    v-model="data_local.marca"       
                    :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"               
                    class="w-full">
                </v-select> 
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">                  
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_modelo')}}</label> 
                <v-select                       
                    label="modelo"        
                    :reduce="m => m.modelo"                
                    :options="listaModeloVeiculos" 
                    :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"
                    v-model="data_local.modelo"                      
                    class="w-full">
                </v-select> 
            </div> 
            <div class="vx-col sm:w-1/3 w-full mb-2" v-if="data_local.modelo === 'Outro'">
                <label class="vs-input--label">{{$t('TelaAlterarVeiculo_lModeloOutro')}}</label>
                <vs-input class="w-full" v-model="data_local.modeloOutro" icon="label" :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"/>
            </div>               
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col w-1/4">
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_cor')}}</label> 
                  <vs-input class="w-full" v-model="data_local.cor" icon="color_lens"  maxlength="45" :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"/>
            </div>     
            <div class="vx-col w-1/4">
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_placa')}}</label> 
                <vs-input class="w-full" v-model="data_local.placa" v-mask="['AAA-#X##', 'AAA-#X##']" icon="calendar_view_day" :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"/>
            </div> 
            <div class="vx-col w-1/4">
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_nomeMotorista')}}</label>                 
                <vs-input class="w-full" v-model="data_local.nomeMotorista" icon="people" v-if="!isVeiculoGeral" :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"/>
                <v-select v-if="isVeiculoGeral"                   
                    class="v-select"  
                    label="nome"                  
                    :options="listaMotoristas" 
                    v-model="data_local.motorista"
                    :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"
                    style="min-width: 215px"></v-select>
            </div> 
            <div class="vx-col w-1/4">
                <label class="vs-input--label">{{$t('TelaVeiculoExterno_ativo')}}</label>          
                <vs-checkbox v-model="data_local.ativo" size="small" :disabled="registroOriginal.hasOwnProperty('id') && isVeiculoGeral"></vs-checkbox>    
            </div>
        </div>        
        <div class="vx-row mb-4" v-if="data_local.dataHoraCadastroFormatada">
            <div class="vx-col w-1/4">
                <label class="vs-input--label" >{{$t('TelaVeiculoExterno_dataHoraCadastro')}}</label> 
                  {{data_local.dataHoraCadastroFormatada}}
            </div>     
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col w-3/4">
                <vs-alert active="true" class="mb-2" v-if="isVeiculoGeral && !registroOriginal.hasOwnProperty('id')">
                    <p>Invista no controle da sua frota! </p> 
                    Este veículo terá acesso a todas as funcionalidades da nossa plataforma por apenas por R$ {{valorMensalidade}}/mês ( preço promocional de <s>R$ 49,90</s> por R$ {{valorMensalidade}} ).
                    <br/>
                    Ao clicar em Gravar, você garante essa vantagem exclusiva e autoriza a cobrança mensal.
                    <br/>
                </vs-alert>
                <vs-alert active="true" class="mb-2" v-if="isVeiculoGeral && registroOriginal.hasOwnProperty('id')" color="warning">            
                    As alterações dos dados do veículo devem ser feitas através da funcionalidade  <a @click="routeAlteracaoVeiculo" style="cursor: pointer">CONFIGURAÇÃO -> ALTERAÇÃO VEÍCULOS</a>
                </vs-alert>
            </div>
        </div>
        
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">                    
                <vs-button class="ml-auto mt-2" size="small" @click="gravar" v-if="(!isVeiculoGeral || (temCapacidadeMaster && isVeiculoGeral && !registroOriginal.hasOwnProperty('id')))" :disabled="!temPermissaoGravar && !temCapacidadeMaster" color="success">{{ $t('Btn_Gravar') }}</vs-button>
                <vs-button class="ml-4 mt-2" size="small" :color="data_local.ativo ? 'warning' : 'success'"  @click="alterarInativacao" v-if="temCapacidadeMaster && isDeletable && isVeiculoGeral && registroOriginal.hasOwnProperty('id')" :disabled="!temPermissaoGravar && !temCapacidadeMaster" >{{ data_local.ativo ? 'INATIVAR' : 'ATIVAR' }}</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" @click="excluir" :disabled="!temPermissaoGravar && !temCapacidadeMaster" v-show="isDeletable" color="danger">{{ $t('Btn_Excluir') }}</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>             
            </div>
        </div>
    </vx-card>  
  </div>
</template>

<script>
import axios from "@/axios.js"

const URL_SERVLET = "/rest/VeiculoExterno/";
const NAME_ROUTE_SEARCH = "frota-veiculo-externo";

import { CONSTANTE_OPCAO_TIPO_VEICULO_EXTERNO_ARRAY } from '@/constantesComboBox.js'
import { CONSTANTE_TIPO_VEICULO } from '@/constantesImagens.js'

export default {  
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
            return {tipo: 'portaria', marca: '', modelo: '', placa: '', cor: '', nomeMotorista: '', ativo: true, tipoVeiculo : null, motorista: null}
       }
    },
  },
  data() {
    return {            
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),
        listaMarcaVeiculos: [], 
        listaModeloVeiculos: [], 
        listaMotoristas: [],
        valorMensalidade: "25,00",
        publicPath: process.env.BASE_URL         
    }
  },    
  mounted() {
    this.fetchListaMotoristas();
    this.fetchListaMarcaVeiculos();
    this.fetchListaModeloVeiculos();
      if (this.registroOriginal.hasOwnProperty('id') && !this.isVeiculoGeral) {
          this.findById();  
      }  else {
        this.getValorMensalidade();
      }
  },
  created(){
    this.listaOpcoesTipoVeiculo = CONSTANTE_OPCAO_TIPO_VEICULO_EXTERNO_ARRAY; 
    this.listaTiposVeiculos = CONSTANTE_TIPO_VEICULO;  
  },
  computed: {  
    isConcept(){
        return this.$store.state.AppActiveUser.idEmpresa === 1;
    },
    isVeiculoGeral(){
        return (this.data_local && this.data_local.tipo === 'geral');
    },  
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },   
    validateForm() {
      return !this.errors.any()
    },    
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }
  },
  methods: {   
    gravar(){               
        if (this.isConcept && this.isVeiculoGeral) {
        this.$vs.dialog({ type: 'confirm', color: 'danger', title: `Atenção`,
            text: 'Confirma o aceite do cadastro do veículo com a cobrança mensal de R$ ' + this.valorMensalidade + ' ?', acceptText: 'SIM', cancelText: 'NÃO',
            accept: this.gravarRequest });          
        } else {
            this.gravarRequest();
        }    
     },
    getValorMensalidade() {
        const params = new URLSearchParams();       
        params.append('idCliente', this.$store.state.AppActiveUser.id);      
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);    
                        
        axios.post(URL_SERVLET + "ConsultarValorMensalidade", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.valorMensalidade = response.data.Resultado.mensagem;                 
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - getValorMensalidade - " + error); 
        })  
    },   
    fetchListaMotoristas() {                      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');   
        params.append('idCliente', this.$store.state.AppActiveUser.id);   
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 
        params.append('motoristaAtivo', true);   

        axios.post("/MotoristasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {
                this.listaMotoristas = response.data;                
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error); 
        })                            
    },
    fetchListaMarcaVeiculos() {
      const params = new URLSearchParams();
      params.append('pagina', -1);
      axios.post("/rest/MarcaVeiculo/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {                    
          this.listaMarcaVeiculos = response.data.Resultado.lista.item;
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("Error Fech Lista Marcas Veiculos " + error);        
      })      
    },  
    fetchListaModeloVeiculos() {
      const params = new URLSearchParams();
      params.append('pagina', -1);
      axios.post("/rest/ModeloVeiculo/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {                    
          this.listaModeloVeiculos = response.data.Resultado.lista.item;
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("Error Fech Lista Modelo Veiculos " + error);        
      })      
    }, 
    findById() {
        const params = new URLSearchParams();       
        params.append('idCliente', this.$store.state.AppActiveUser.id);      
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);    
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "Recuperar", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.VeiculoExterno;                 
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        if (this.isVeiculoGeral && !this.isAcessoMaster) {
            this.$vs.dialog({ color: 'danger', title: 'Erro', text: 'Você não tem permissão para excluir esse veículo', acceptText: 'OK'});
            return;
        }

        this.$vs.loading();  
        const params = new URLSearchParams();      
        params.append('idCliente', this.$store.state.AppActiveUser.id);      
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);     
        params.append('id', this.data_local.id);           
        params.append('tipo', this.data_local.tipo);
        params.append('ativo', this.data_local.ativo);   
                
        axios.post(URL_SERVLET + "Remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();  
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                if (response.data.Resultado.hasOwnProperty("error")) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();  
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravarRequest() {      
        
        if (this.isVeiculoGeral && !this.temCapacidadeMaster) {
            this.$vs.dialog({ color: 'danger', title: 'Erro', text: 'Você não tem permissão para inserir esse veículo. Somente o acesso MASTER.', acceptText: 'OK'});
            return;
        }

        if (this.formularioValido()) { 
            this.$vs.loading(); 

            const params = new URLSearchParams();   
            params.append('idCliente', this.$store.state.AppActiveUser.id);      
            params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);         
            params.append('tipo', this.data_local.tipo);
            
            if (this.data_local.hasOwnProperty("id")) {
                params.append('id', this.data_local.id);               
            }  
            params.append('marca', this.data_local.marca);    
            params.append('modelo', this.data_local.modelo);      
            params.append('placa', this.data_local.placa);      
            if (this.data_local.cor) {
                params.append('cor', this.data_local.cor);      
            }
            params.append('nomeMotorista', this.data_local.nomeMotorista);      
            params.append('ativo', this.data_local.ativo);   
            
            if (this.isVeiculoGeral) {
                params.append('motorista.id', this.data_local.motorista.id);   
                params.append('motorista.nome', this.data_local.motorista.nome);   
                params.append('tipoVeiculo', this.data_local.tipoVeiculo);   
            }
                             
            axios.post(URL_SERVLET+ "Gravar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close(); 
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {                    
                    if (response.data.Resultado.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                   
                }
            })
            .catch((error) => {                 
                this.$vs.loading.close(); 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.marca) {
            this.errorsValidacao.push(this.$t('TelaVeiculoExterno_marca') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }
        if (!this.data_local.modelo) {
            this.errorsValidacao.push(this.$t('TelaVeiculoExterno_modelo') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }
        if (!this.data_local.cor) {
            this.errorsValidacao.push(this.$t('TelaVeiculoExterno_cor') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }
        if (!this.data_local.placa) {
            this.errorsValidacao.push(this.$t('TelaVeiculoExterno_placa') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (this.isVeiculoGeral) {
            if (!this.data_local.tipoVeiculo) {
                this.errorsValidacao.push("Tipo Veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }

            if (!this.data_local.motorista || !this.data_local.motorista.id) {
                this.errorsValidacao.push(this.$t('TelaVeiculoExterno_nomeMotorista') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        } else {
            if (!this.data_local.nomeMotorista) {
                this.errorsValidacao.push(this.$t('TelaVeiculoExterno_nomeMotorista') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },    
    alterarInativacao() {        
        
        this.$vs.loading(); 

        const params = new URLSearchParams();   
        params.append('idCliente', this.$store.state.AppActiveUser.id);      
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);         
        params.append('tipo', this.data_local.tipo);
        params.append('id', this.data_local.id);                                 
        params.append('ativo', !this.data_local.ativo);   
                            
        axios.post(URL_SERVLET+ "AlterarInativacao", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close(); 
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                    
                if (response.data.Resultado.hasOwnProperty("error")) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH });
                }                   
            }
        })
        .catch((error) => {                 
            this.$vs.loading.close(); 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
         
    },
    routeAlteracaoVeiculo() {      
      this.$router.push({
            name: 'configuracao-alterar-veiculo'                     
      })
    },     
  }
}
</script>